
export class Davenfor {


    public constructor(

        public id?:number,
        public category?: string,
        public createdAt?: string,
        public deletedAt?: string,
        public confirmedAt?: string,
        public nameEnglish?: string,
        public nameEnglishSpouse?: string,
        public nameHebrew?: string,
        public nameHebrewSpouse?: string,
        public note?: string,
        public submitterToReceive?: boolean,
        public updatedAt?: string,
        public userEmail?: string
    ) { }

 }